module.exports = __webpack_public_path__ + "img/remainder2.ef70695a.svg";